export default __webpack_public_path__ + "static/facebook-og-dc4e1962b0a58c63cd387fcea00d2225.png";